import type { PiniaPlugin } from 'pinia';

// Pinia equivalent of the Vuex analytics plugin (src/vuex/plugins/analytics.js).
// Each store that needs re-identification wires up its $subscribe logic here
// when it migrates. Only subscribes on stores that actually need it.
export const analyticsPlugin: PiniaPlugin = ({ store }) => {
    if (store.$id === 'auth') {
        // APP-157986: re-identify when user profile fields change
        // (equivalent to auth/setProperty with reIdentify: true)
        // store.$subscribe(() => { ... });
    }

    if (store.$id === 'userSettings') {
        // APP-157979: re-identify when discoverGetStartedPreferences change
        // (equivalent to userSettings/setMapAtKey)
        // store.$subscribe(() => { ... });
    }
};
